let PopUpService = function (Restangular) {
    const ServiceAPI = Restangular.all('v2/admin/campaign_popups');

    let getpopUpsList = (query) => {
      return ServiceAPI.customGET("", query);
    }

    let getRegionsList = () => {
      return ServiceAPI.customGET('regions');
    } 
  
    let save = (resource) => {
      if (resource.id) {
        let copyData = angular.copy(resource);
        delete copyData.id;
        return ServiceAPI.customPUT(copyData, resource.id);
      } else {
        return ServiceAPI.post(resource);
      }
    }
  
    let show = (id) => {
      return ServiceAPI.get(id);
    }
  
    let destroy = (resource) => {
      return ServiceAPI.customDELETE(resource.id);
    }
  
    return { getpopUpsList, getRegionsList, save, show, destroy } ;
  };
  
  PopUpService.$inject = ['Restangular'];
  
  export default PopUpService;
  


// WEBPACK FOOTER //
// ./client/app/components/pop-up/pop-up.service.js